export const NEW_MENU = {
    componentType: 'wixui.Menu',
    skin: 'wixui.skins.Menu',
    type: 'Container',
    dataType: 'MenuData'
}

export const MENU_DROPDOWN_ICON = {
    SPACING_BETWEEN_LABEL_AND_DROPDOWN_ICON: '6px',
    ICON_SIZE: '10px'
}
